import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import classNames from "classnames";
import ReactTooltip from "react-tooltip";
import { useLocation } from "react-router-dom";

import { DEFAULT_PIC, getDashboardPath } from "../../../../constants";
import * as actions from "../../../../store/actions";

import "./Patients.css";
import PatientDetails from "./PatientDetails";
import PatientNotes from "../PatientNotes";
import PatientFiles from "../PatientFiles";
import Tabs from "../../../../components/uiElements/navTabs/Tabs";
import AppointmentIcon from "../../../../components/uiElements/icons/profileIcons/AppointmentIcons";
import BlockPatientModal from "../../../../components/uiElements/modal/BlockPatientModal";
import { getUserData } from "../../../../utils/localStorage";
import Button from "../../../../components/formElements/button/Button";
import PatientPrescriptions from "../PatientPrescriptions";
import PatientAppointments from "../../../Dashboard/Patients/PatientAppointments/index";
import { useHistory } from "react-router";

const PatientProfile = ({
  patient,
  getPatient,
  match,
  history,
  patientBlock,
  modalViewMode,
  onAccept,
  onDeny,
  appointment,
  profileView,
}) => {
  const [tab, setTab] = useState("details");
  const [modal, setModal] = useState(false);
  const [view, setView] = useState(false);
  const lo = useLocation();

  const windowHistory = useHistory();

  const patientId =
    match.params.id || localStorage.getItem("visitNowPatientId");

  const viewMode = modalViewMode || localStorage.getItem("viewMode");

  useEffect(() => {
    getPatient(patientId);
    setView(lo.state?.pop);
    // eslint-disable-next-line
  }, [patientId]);

  const tabs = useMemo(
    () => [
      { name: "details", value: "Details", to: patientId},
      { name: "notes", value: "Notes", to: patientId },
      { name: "files", value: "Files", to: patientId },
      { name: "prescriptions", value: "Prescriptions", to: patientId },
      { name: "appointments", value: "Appointments", to: patientId },
    ],
    []
  );

  const getAge = (dateString) => {
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const user_data = getUserData();

  return useMemo(() => {
    return (
      <>
        {modal && (
          <BlockPatientModal
            isOpen={modal}
            onSuccess={() => {
              patientBlock(
                { patient: patient.id, doctor: getUserData().id },
                () => {
                  history.goBack();
                }
              );
            }}
            closeModal={() => setModal(false)}
            label={`${patient?.first_name} ${patient?.last_name}`}
            type="block"
          />
        )}
        <div
          className="m-n4"
          style={viewMode && { overflowX: "hidden", paddingBottom: "1%" }}
        >
          <div className="patient-container">
            <div className="row d-flex pt-3 pb-4">
              <div
                className={classNames("col-md-5", viewMode && "pt-2 pl-4")}
              >
                {!viewMode && (
                  <span
                    className="px-3"
                    style={{ cursor: "pointer" }}
                  >
                    <AppointmentIcon
                      type="leftArrow"
                      onClick={() =>
                        windowHistory.push({
                          pathname: getDashboardPath("/patients"),
                          state: { pop: true },
                        })
                      }
                    />
                  </span>
                )}
                <img
                  src={patient?.image || DEFAULT_PIC}
                  className="profile-image-secondary"
                  alt={patient?.id}
                />
                <span
                  style={{ verticalAlign: "middle" }}
                  className="pl-2 appointment-font-secondary"
                >
                  {`${patient?.first_name} ${patient?.last_name}`} -{" "}
                  {`${getAge(patient?.date_of_birth)} Years`}
                </span>
              </div>
              <div className="col-md-6 text-right">
                {!viewMode ? (
                  <span
                    data-tip
                    className=""
                    onClick={() => setModal(true)}
                    style={{ cursor: "pointer" }}
                  >
                    <AppointmentIcon type="dashCircle" />
                    <ReactTooltip place="bottom">Block</ReactTooltip>
                  </span>
                ) : (
                  modalViewMode && (
                    <>
                      <Button
                        label={
                          appointment.doctor_status === "REQUESTED" ||
                          appointment.guest_doctor_status === "REQUESTED"
                            ? "Accept and start call"
                            : "Rejoin"
                        }
                        className={
                          appointment.doctor_status === "REQUESTED" ||
                          appointment.guest_doctor_status === "REQUESTED"
                            ? "w-auto mr-2 h-75"
                            : "col-md-3 px-3 h-75 mr-2"
                        }
                        onClick={onAccept}
                      />
                      <Button
                        label={
                          appointment.doctor_status === "REQUESTED" ||
                          appointment.guest_doctor_status === "REQUESTED"
                            ? "Deny"
                            : "End"
                        }
                        className="col-md-3 px-3 h-75"
                        onClick={onDeny}
                      />
                    </>
                  )
                )}
              </div>
            </div>
            <Tabs
              tabs={tabs}
              onChange={(tab) => setTab(tab)}
              activeTab={tab}
              user_data={user_data}
            />
          </div>
          {tab === "details" && <PatientDetails patient={patient} />}
          {tab === "notes" && <PatientNotes profileNote={view} />}
          {tab === "files" && <PatientFiles />}
          {tab === "prescriptions" && <PatientPrescriptions />}
          {tab === "appointments" && <PatientAppointments />}
        </div>
      </>
    );
  }, [modal, viewMode, patient, tabs, tab, appointment, view, history, patientBlock, onAccept, onDeny]);
};

const mapStoreToProps = ({ dashboard }) => ({
  patient: dashboard.patients.patient,
});

const mapDispatchToProps = (dispatch) => ({
  getPatient: (patientId) => dispatch(actions.getPatient(patientId)),
  patientBlock: (payload, cb) => dispatch(actions.patientBlock(payload, cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(React.memo(PatientProfile))
);
